import { useTranslation } from 'react-i18next';
import styles from './RouteLoadingFallback.module.css';

/** Suspense fallback while a route chunk loads (the same look the app has always used). */
export function RouteLoadingFallback() {
  const { t } = useTranslation('common');
  return (
    <div className={`app-canvas-wash ${styles.root}`}>
      <div className={`text-body-m ${styles.message}`}>{t('loading')}</div>
    </div>
  );
}
